import { PaymentTaskState } from "../../../enums/tasks";


export const AWAITING_COLLECTION = PaymentTaskState.SCHEDULED as string
export const PENDING = PaymentTaskState.OUT_FOR_PAYMENT as string
export const IN_PROGRESS = `${PaymentTaskState.IN_PROGRESS},${PaymentTaskState.AWAITING_RETURN}`
export const FINISHED = [PaymentTaskState.COMPLETED, PaymentTaskState.CANCELLED, PaymentTaskState.FAILED].join(",")
export const ALL = [PaymentTaskState.SCHEDULED,PaymentTaskState.IN_PROGRESS,PaymentTaskState.AWAITING_RETURN,PaymentTaskState.COMPLETED, PaymentTaskState.CANCELLED, PaymentTaskState.FAILED].join(",")

export type TASK_STATE_CATEGORY =
    | PaymentTaskState.SCHEDULED
    | PaymentTaskState.OUT_FOR_PAYMENT
    | `${PaymentTaskState.IN_PROGRESS},${PaymentTaskState.AWAITING_RETURN}`
    | `${PaymentTaskState.COMPLETED},${PaymentTaskState.CANCELLED},${PaymentTaskState.FAILED}`
    | `${PaymentTaskState.SCHEDULED},${PaymentTaskState.OUT_FOR_PAYMENT},${PaymentTaskState.IN_PROGRESS},${PaymentTaskState.AWAITING_RETURN},${PaymentTaskState.COMPLETED},${PaymentTaskState.CANCELLED},${PaymentTaskState.FAILED}`;
